import { Chip, TextField } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import React from "react"

const TagsTextField = ({
  label = "Email Address(es)",
  placeholder = "Type address and press enter...",
  inputProps: inputPropsIn,
  onChange,
  ...props
}) => {
  const inputProps = { label, placeholder, ...inputPropsIn }

  const handleChange = (event, option) => {
    onChange && onChange(event, option)
  }

  return (
    <Autocomplete
      options={[]}
      freeSolo
      multiple
      renderTags={(value, getTagProps) =>
        value.map((option, index) => <Chip variant="outlined" label={option} {...getTagProps({ index })} />)
      }
      renderInput={(params) => <TextField {...params} variant="outlined" {...inputProps} />}
      onChange={handleChange}
      {...props}
    />
  )
}

export default TagsTextField
